<template>
  <div class="mb-5">
    <div>
      <campaign-stat-section-heading
        title="Enquiry"
        description="Total number of enquiries via the channels available online"
        :loading="loading"
      ></campaign-stat-section-heading>
    </div>
    <div class="stat-items-container" v-if="hasData">
      <stat-item-card
        v-if="enquiryViaEmail"
        :value="enquiryViaEmail"
        label="Enquiry via Email"
        tooltip="The number of times people have taken action to reveal agent email details"
      ></stat-item-card>

      <stat-item-card
        v-if="enquiryViaPhone"
        :value="enquiryViaPhone"
        label="Enquiry via Phone"
        tooltip="The number of times this has been clicked to generate an agent call"
      ></stat-item-card>

      <stat-item-card
        v-if="enquiryViaForm"
        :value="enquiryViaForm"
        label="Enquiry via Form"
        tooltip="The number of times an enquiry has been submitted via web form"
      ></stat-item-card>

      <stat-item-card
        v-if="enquiryViaSocial"
        :value="enquiryViaSocial"
        label="Enquiry via Social"
        tooltip="The number of times an enquiry has been submitted via social form"
      ></stat-item-card>
    </div>
    <no-stat-data-available
      v-if="!hasData && !loading"
      sectionTitle="enquiries"
    ></no-stat-data-available>
  </div>
</template>
<script>
import StatItemCard from './StatItemCard.vue';
import CampaignStatSectionHeading from './CampaignStatSectionHeading.vue';
import NoStatDataAvailable from './NoStatDataAvailable.vue';
export default {
  props: [
    'enquiryViaSocial',
    'enquiryViaForm',
    'enquiryViaPhone',
    'enquiryViaEmail',
    'loading'
  ],
  components: {
    StatItemCard,
    CampaignStatSectionHeading,
    NoStatDataAvailable,
  },
  computed: {
    hasData() {
      if (this.loading) return true;
      
      return (
        this.enquiryViaSocial ||
        this.enquiryViaForm ||
        this.enquiryViaPhone ||
        this.enquiryViaEmail
      );
    },
  },
};
</script>

<style>
.stat-items-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
}
</style>
